import env from '../../constants/env';
import { GLOBALS } from '../actions/utils/actionCases';

const initialState = {
	isLoading: false,
	isLoadingTimerId: undefined,
	isPageScroll: true,
	isLandscape: undefined,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case GLOBALS.INITIALIZE:
			return initialState;
		case GLOBALS.IS_LOADING: {
			// Prevents lock state if external isGlobalLoading(false) somehow fails to sent
			// Does so with a timer that sends if no other triggers are sent
			const oldIsLoadingTimerId = state.isLoadingTimerId;
			let newIsLoadingTimerId;
			if(oldIsLoadingTimerId) clearTimeout(oldIsLoadingTimerId);
			if(action.bool) {
				newIsLoadingTimerId = setTimeout(() => {
					action.dispatch({
						type: GLOBALS.IS_LOADING,
						bool: false,
						dispatch: action.dispatch
					});
				}, parseInt(env.WEBSOCKET_REST_TIMEOUT));
			}
			return {
				...state,
				isLoadingTimerId: newIsLoadingTimerId,
				isLoading: action.bool,
			};
		}
		case GLOBALS.IS_PAGE_SCROLL:
			return {
				...state,
				isPageScroll: action.bool,
			};
		case GLOBALS.IS_LANDSCAPE:
			return {
				...state,
				isLandscape: action.bool,

			};
		default:
			return state;
	}
};